import React from 'react';
import {PLAYER_COLOR_INITIAL_NAME_MAPPING} from '../../configs/players';
import {getLocalBotLeagueId} from '../../configs/localBotLeagues';
import {getLocalBonusTooltip} from '../../utils/bots/getLocalBotGrowthBonusNote';
import VisibleBotMark from '../VisibleBotMark/VisibleBotMark';
import PlayerBonusToggle from '../PlayerBonusToggle/PlayerBonusToggle';

const LOCAL_BONUS_TOOLTIP = 'Дополнительный бонус для локальной игры: увеличивает стартовые монеты, доход монет (у старших уровней — и за каждый город) и действия в фазе Строительства.';

/**
 * Настройки одного игрока локальной партии — общие для строки на телефоне и
 * карточки на десктопе.
 */

export const HotSeatPlayerNameField = ({color, name, hasError, isYou, onChange}) => (
  <div className="player-name-input-wrapper">
    <input
      type="text"
      className={`player-name-input ${hasError ? 'player-name-input-error' : ''} ${
        isYou ? 'player-name-input_with-badge' : ''
      }`}
      value={name}
      onChange={(e) => onChange(color, e.target.value)}
      placeholder={`Имя игрока (${PLAYER_COLOR_INITIAL_NAME_MAPPING[color]})`}
    />
    {isYou && <span className="lobby-you-badge player-name-you-badge">Вы</span>}
  </div>
);

/**
 * @param {boolean} isLocalBot — станет ли игрок ботом локальной партии (см.
 *   prepareLocalMatchPlayers): такому боту полагаются значок, а по его уровню
 *   бонуса — прибавка к росту отрядов и подкрутка костей («божество»). В
 *   редакторе миссий — нет: автор играет за всех, ботами игроки станут только
 *   при прохождении миссии
 */
export const HotSeatPlayerBotToggle = ({color, isBot, isLocalBot, bonus, onToggle}) => (
  <button
    type="button"
    className="player-bot-toggle"
    onClick={() => onToggle(color)}
    title={isBot ? 'Игрок под управлением компьютера. Нажмите, чтобы играл человек.' : 'Игрок под управлением человека. Нажмите, чтобы играл компьютер.'}
  >
    <span>{isBot ? 'Бот' : 'Живой игрок'}</span>
    {/* Бота отличает не заливка кнопки, а значок рядом — тот же,
        которым он будет помечен в партии, по его уровню бонуса
        (меняется вместе с кнопкой бонуса). В редакторе миссий
        значка не будет и в самой партии (автор играет за всех) —
        не обещаем его и здесь */}
    {isLocalBot && (
      <VisibleBotMark
        player={{isBot, isLocalBot, bonus}}
        className={`player-bot-toggle-mark player-bot-toggle-mark_${getLocalBotLeagueId(bonus)}`}
      />
    )}
  </button>
);

export const HotSeatPlayerBonusToggle = ({color, bonus, isLocalBot, onCycle}) => (
  <PlayerBonusToggle
    bonus={bonus}
    onCycle={() => onCycle(color)}
    // Любому игроку уровень дает экономику, а «божество» — и очки
    // победы к доходу. Боту локальной партии старшие уровни дают
    // еще и прибавку к росту отрядов, «божество» — и кость урона,
    // которая всегда 0: об этом подсказка говорит только боту
    tooltipText={getLocalBonusTooltip(LOCAL_BONUS_TOOLTIP, isLocalBot)}
  />
);
